import React, { FC } from 'react';
import { useFormContext } from 'react-hook-form';

import { CurrencyInput } from '@eika/currency-input';

import { useTranslation } from '../../translations';

export type AndelFellesgjeldFormData = {
    andelFellesgjeld: number;
};

const AndelFellesgjeld: FC = () => {
    const { kjoepBolig } = useTranslation();
    const { register } = useFormContext<AndelFellesgjeldFormData>();

    return (
        <div className="max-width-400">
            <CurrencyInput
                label={kjoepBolig.labelAndelFellesgjeld}
                placeholder=""
                type="tel"
                {...register('andelFellesgjeld')}
            />
        </div>
    );
};

export default AndelFellesgjeld;
